import { API_BASE } from './config';

/**
 * Bygger korrekt URL för profilbilder.
 *
 * Backend sparar avatar_url som t.ex:
 * /api/media/avatar/user_xxx.jpg?v=123
 */
export function resolveAvatarUrl(avatarUrl) {
  if (!avatarUrl || typeof avatarUrl !== 'string') {
    return undefined;
  }

  const value = avatarUrl.trim();

  if (!value) {
    return undefined;
  }

  if (
    value.startsWith('http://') ||
    value.startsWith('https://') ||
    value.startsWith('data:') ||
    value.startsWith('blob:')
  ) {
    return value;
  }

  const base = (API_BASE || '').replace(/\/$/, '');

  if (!base) {
    return value;
  }

  return `${base}/${value.replace(/^\/+/, '')}`;
}

export default resolveAvatarUrl;